<template>
  <div class="private-background">
    <Nav></Nav>

    <v-main>
      <v-card
          id="search-profiles"
          class="mx-auto mt-10 mb-10 "
          max-width="1080"
      >

        <FilteringSearch></FilteringSearch>

        <v-sheet
            id="container-profiles"
            class="overflow-y-auto profiles-background"
        >
          <v-container style="height: 1000px;overflow-x:hidden;" >

            <v-row
                align="end"
                fill-height
                class="pt-10 mb-16"
                v-if="loading === false && profiles !== null && profiles.length > 0"
            >

              <v-col
                  cols="12"
                  md="4"
                  sm="6"
                  xs="12"
                  v-for="(profile, j) in profiles" :key="'elements-'+j"
                  class="float-left"
              >
                <v-card width="325" class="mx-auto">
                  <LocalizedLink :to="profile.username" >
                    <v-img
                      :src="getCdn() + profile.folder + '/' + profile.image"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="400px"
                  >
                    <v-app-bar
                        flat
                        color="rgba(0, 0, 0, 0)"
                    >
                      <v-toolbar-title class="text-h6 white--text pl-0">
                        <v-btn class="simulate-disabled online" icon v-if="profile.online === true">
                          <v-icon color="green">mdi-account-circle</v-icon>
                        </v-btn>

                        <v-btn class="simulate-disabled offline" icon v-if="profile.online === false">
                          <v-icon color="red">mdi-account-circle-outline</v-icon>
                        </v-btn>
                        @{{profile.username}}
                      </v-toolbar-title>

                      <v-spacer></v-spacer>

                      <v-btn
                          color="white"
                          icon
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </v-app-bar>

                  </v-img>
                  </LocalizedLink>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <div v-for="(male, j) in profile.members.male" :key="'males-'+j">
                      <v-btn class="simulate-disabled mr-5" icon v-if="profile.members.male && profile.members.male.length > 0">
                        <v-icon color="blue">mdi-gender-male</v-icon>
                        <span>{{male.age}}</span>
                      </v-btn>
                    </div>

                    <div v-for="(female, j) in profile.members.female" :key="'females-'+j">
                      <v-btn class="simulate-disabled mr-5" icon v-if="profile.members.female && profile.members.female.length > 0">
                          <v-icon color="pink">mdi-gender-female</v-icon>
                          <span>{{female.age}}</span>
                      </v-btn>
                    </div>

                    <div v-for="(shemale, j) in profile.members.shemale" :key="'shemale-'+j">
                      <v-btn class="simulate-disabled mr-5" icon v-if="profile.members.shemale && profile.members.shemale.length > 0">
                        <v-icon color="green">mdi-gender-male-female</v-icon>
                        <span>{{shemale.age}}</span>
                      </v-btn>
                    </div>

                    <Likes :profilePosition="j" :profileId="profile.profileId" :hasMyLike="profile.hasMyLike" :likes="profile.likes" @update-likes="updateLikes"></Likes>
                    <QuickMessages :profile="profile.username" :profileId="profile.profileId"></QuickMessages>

                  </v-card-actions>
                </v-card>
              </v-col>

              <v-row class="d-flex float-none" style="width:100%">
                <v-col cols="12">
                  <div class="d-flex align-center flex-column bg-grey-lighten-1 pa-6">

                    <v-pagination
                        v-model="page"
                        :length="totalPages"
                        circle
                        :total-visible="7"
                        :value="page"
                        @input="changePage"
                    ></v-pagination>

                  </div>
                </v-col>
              </v-row>
            </v-row>
            <v-row align="content-center"
                   fill-height
                   class="pt-10 mb-16"
                   v-else-if="loading === true">
              <v-col
                  cols="12"
                  md="4"
                  sm="6"
                  xs="12"
                  class="mx-auto"
                  style="display:flex;justify-content: center;margin-top:35%"
              >
                <fingerprint-spinner
                    :animation-duration="3000"
                    :size="64"
                    color="rgb(194, 194, 194)"
                />
              </v-col>
            </v-row>
            <v-row v-else-if="loading === false && error === false ">
              <v-col
                  cols="12"
                  md="4"
                  sm="6"
                  xs="12"
                  class="mx-auto"
                  style="text-align:center;margin-top:35%;color:black"
              >
                No se ha encontrado ningún perfil con estos criterios de búsqueda
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                  cols="12"
                  md="4"
                  sm="6"
                  xs="12"
                  class="mx-auto"
                  style="text-align:center;margin-top:35%;color:black"
              >
                There was an error trying to get the profiles, please try again later
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-card>
    </v-main>

  </div>
</template>

<script>
import Nav from "@/components/Nav"
import FilteringSearch from "@/components/FilteringSearch"
import FiltersStorage from "@/services/FiltersStorage"
import Profiles from "@/services/Profiles";
import Environment from "@/services/Environment";
import LocalizedLink from "@/components/LocalizedLink"
import QuickMessages from "@/components/QuickMessages"
import Likes from "@/components/Likes"
import "../css/private.css";
import { FingerprintSpinner } from 'epic-spinners'
import EventBus from "../EventBus.js"
import store from "../store/index.js";

export default {
  data: () => ({
    session: null,
    profiles: null,
    tab: null,
    drawer: false,
    group: null,
    loading: true,
    error: false,
    locale: 'es',
    limit: 12,
    offset : 0,
    page: 1,
    pagesToBeShown: [],
    filters: {'offset': 0, 'limit': 12},
    totalProfiles: 0,
    totalPages: 0
  }),
  methods: {
    changePage(page){
      window.location = '/'+this.locale+'/search/'+page
    },
    getProfiles(filters) {
      this.loading = true

      Profiles.getLatestProfiles(store.state.tokenStored, filters).then((response)=> {
        this.loading = false

        if (!response || !response.data || response.data.success === false) {
          this.profiles = []
          this.error = true
          return
        }

        this.error = false
        this.totalProfiles = response.totalProfiles
        this.totalPages = Math.ceil(this.totalProfiles / this.limit)
        this.profiles = response.data
      }).finally(()=> {
        this.loading = false
      })
    },
    getCdn(){
      return Environment.getCdn()
    },
    updateLikes(position, likes, hasMyLike){
      this.profiles[position].likes = likes
      this.profiles[position].hasMyLike = hasMyLike
    }
  },
  created (){

    this.locale = this.$route.params.locale
    this.page = parseInt(this.$route.params.page, 10) ? parseInt(this.$route.params.page, 10) : 1

    if (FiltersStorage.hasFiltersStored()) {
      this.filters = FiltersStorage.getFilters();
    }

    this.filters.offset = ((this.page-1) * this.limit)
    this.filters.limit = this.limit
    this.getProfiles(this.filters)
    EventBus.$on("filterParameters", (resetFilters) => {
      this.page = 1
      resetFilters.offset = this.offset
      resetFilters.limit = this.limit
      this.filters = Object.assign({}, resetFilters);
      FiltersStorage.wipeOut();
      FiltersStorage.saveFilters(this.filters)
      this.getProfiles(this.filters)
    })
  },
  components: { Nav, FilteringSearch, LocalizedLink, QuickMessages, FingerprintSpinner, Likes }
}
</script>